module.exports = __webpack_public_path__ + "sprout.5cb488ee5ac24cd51b5a.svg";


//////////////////
// WEBPACK FOOTER
// /Users/emrevolkanucar/Desktop/Angular/etigumus/src/assets/img/sprout.svg
// module id = ../../../../../src/assets/img/sprout.svg
// module chunks = main